import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { SectionCard } from "components/AtomsV2";

// Internal Components
import UnifiedEMS from "./UnifiedEMS";

function EnergyManagementAndFlexibility({ community }) {
  const { t } = useTranslation(["community"]);

  return (
    <SectionCard id="energy" icon="bolt" title={t("energy.title")}>
      <p className="text-[12.5px] text-ink-3 leading-[1.5] -mt-2 mb-4">
        {t("unified_ems.section_description")}
      </p>
      <UnifiedEMS communityId={community.id} />
    </SectionCard>
  );
}

EnergyManagementAndFlexibility.propTypes = {
  community: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default EnergyManagementAndFlexibility;
